<template>
  <o-sales-view
    nav-bar-title="De Lijn"
    title="De Lijn M-ticket"
    image="images/delijn-header.jpg"
    :points="15"
    price="1,80"
    service-cost="0,40"
    :tabs="tabs"
    message="Gereserveerd met telefoonnummer +32 485 07 16 17."
    next-link="/sales/kbc/ticket/confirmation"
  />
</template>

<script>
import OSalesView from '@/components/OSalesView.vue'
export default {
  name: 'DeLijn',
  components: {
    OSalesView
  },
  data() {
    return {
      tabs: [
        {
          label: 'M-ticket',
          isSelected: true
        },
        {
          label: 'M-card 10'
        }
      ]
    }
  }
}
</script>
